import { Loading } from 'react-admin';
import Loadable from 'react-loadable';

const PodList = Loadable({ loader: () => import('./podList'), loading: Loading });
const PodShow = Loadable({ loader: () => import('./podShow'), loading: Loading });

export default { 
  list: PodList,
  show: PodShow,
};